
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 5.924a8.549 8.549 0 0 1-2.363.647 4.077 4.077 0 0 0 1.804-2.266 8.192 8.192 0 0 1-2.6.993 4.099 4.099 0 0 0-7.093 2.804c0 .324.028.637.096.934-3.409-.166-6.425-1.8-8.451-4.288A4.128 4.128 0 0 0 2.83 6.82c0 1.42.732 2.679 1.821 3.407A4.049 4.049 0 0 1 2.8 9.722v.046a4.12 4.12 0 0 0 3.285 4.028 4.094 4.094 0 0 1-1.075.135c-.263 0-.527-.015-.776-.07.531 1.624 2.038 2.818 3.831 2.857a8.238 8.238 0 0 1-5.084 1.748A7.67 7.67 0 0 1 2 18.41a11.543 11.543 0 0 0 6.29 1.84c7.545 0 11.67-6.25 11.67-11.668 0-.18-.006-.356-.015-.53A8.179 8.179 0 0 0 22 5.925Z","fill":"#161313"}})])
          )
        }
      }
    